// layouts/auth/ForgotPassword.jsx
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, TextField, Alert, LinearProgress, Box } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import SoftButton from "components/SoftButton";
import { requestRecoveryEmail } from "../autenticacion/usuarios/services/users";

const isEmailValid = (val) => !!val && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [okMsg, setOkMsg] = useState("");
  const [errMsg, setErrMsg] = useState("");

  const disabled = submitting || !isEmailValid(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setOkMsg(""); setErrMsg("");
    try {
      setSubmitting(true);
      await requestRecoveryEmail(email.trim());
      setOkMsg("Si el correo existe, te enviaremos un enlace para restablecer la contraseña.");
    } catch (e) {
      setErrMsg(e?.message || "No pudimos enviar el correo. Intenta de nuevo.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <SoftBox py={6} display="flex" justifyContent="center">
      <Card sx={{ p: 3, width: "100%", maxWidth: 420 }}>
        <SoftBox mb={2} display="flex" alignItems="center" justifyContent="space-between">
          <SoftTypography variant="h6">¿Olvidaste tu contraseña?</SoftTypography>
          <SoftButton variant="outlined" color="secondary" onClick={() => navigate(-1)}>
            Volver
          </SoftButton>
        </SoftBox>

        <Alert severity="info" sx={{ mb: 2 }}>
          Escribe tu correo y te enviaremos un enlace para restablecer la contraseña.
        </Alert>

        {submitting && <LinearProgress sx={{ mb: 2 }} />}

        {okMsg && <Alert severity="success" sx={{ mb: 2 }}>{okMsg}</Alert>}
        {errMsg && <Alert severity="error" sx={{ mb: 2 }}>{errMsg}</Alert>}

        <Box component="form" onSubmit={handleSubmit} noValidate>
          <TextField
            fullWidth
            type="email"
            label="Correo"
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            autoComplete="email"
            required
            error={!!email && !isEmailValid(email)}
            helperText={!!email && !isEmailValid(email) ? "Correo inválido" : " "}
          />

          <SoftButton
            type="submit"
            variant="gradient"
            color="dark"
            disabled={disabled}
            fullWidth
          >
            {submitting ? "Enviando…" : "Enviar enlace"}
          </SoftButton>
        </Box>
      </Card>
    </SoftBox>
  );
}
